import {Component, OnInit} from '@angular/core';
import {HostListener} from '@angular/core';
import {MediaObserver} from '@angular/flex-layout';
import {getPdfViewZoomLevel} from '../common/utility';

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  resumeSrc = '../../assets/pdf/CKL-DD-Resume-2020.pdf';
  descriptionSrc = '../../assets/pdf/jd-digital-designer.pdf';
  methodologySrc = '../../assets/pdf/digital-design-flow.pdf';
  continuumSrc = '../../assets/pdf/design-skills-continuum.pdf';

  constructor(public mo: MediaObserver) {
  }

  ngOnInit(): void {
    this.getPdfViewZoomLevel();
  }

  @HostListener('window:resize')
  getPdfViewZoomLevel(): number {
    return getPdfViewZoomLevel();
  }
}
